import { render, staticRenderFns } from "./ProAllList.vue?vue&type=template&id=238e53d2&"
import script from "./ProAllList.vue?vue&type=script&lang=js&"
export * from "./ProAllList.vue?vue&type=script&lang=js&"
import style0 from "./ProAllList.vue?vue&type=style&index=0&id=238e53d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports